import { render, staticRenderFns } from "./creative-table.vue?vue&type=template&id=e350fb4a&scoped=true"
import script from "./creative-table.vue?vue&type=script&lang=js"
export * from "./creative-table.vue?vue&type=script&lang=js"
import style0 from "./creative-table.vue?vue&type=style&index=0&id=e350fb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e350fb4a",
  null
  
)

export default component.exports